import { get as _get } from 'lodash';
import * as api from '../common/api/tides';
import { NOT_FOUND } from './status';
import tidesTransform from '../utils/tides/tidesTransform';
import { getUserLegacySettings, getUserBwWindWaveModel } from '../selectors/user';

export const FETCH_TIDES = 'FETCH_TIDES';
export const FETCH_TIDES_SUCCESS = 'FETCH_TIDES_SUCCESS';
export const FETCH_TIDES_FAILURE = 'FETCH_TIDES_FAILURE';

export const fetchTides = coordinates => async (dispatch, getState) => {
  dispatch({
    type: FETCH_TIDES,
  });
  try {
    const userStateDetails = _get(getState(), 'user.details', {});
    const bwWindWaveModel = getUserBwWindWaveModel(getState());
    const legacyUserSettings = getUserLegacySettings(getState());
    let tides = {};
    const { forecast: { printVersion } } = getState();
    if (bwWindWaveModel === 'LOLA' || printVersion) {
      const newTidesData = await api.fetchNewTides(
        coordinates[0],
        coordinates[1],
        userStateDetails,
      );
      tides = tidesTransform(newTidesData, legacyUserSettings);
    } else {
      tides = await api.fetchTides(coordinates[0], coordinates[1], userStateDetails);
    }
    await dispatch({
      type: FETCH_TIDES_SUCCESS,
      tides: tides.tides,
    });
  } catch (error) {
    if (error.statusCode === 400) {
      dispatch({
        type: NOT_FOUND,
        message: `Tides for ${coordinates} could not be found`,
      });
    }
    dispatch({
      type: FETCH_TIDES_FAILURE,
      error,
    });
  }
};



// WEBPACK FOOTER //
// ./src/actions/tides.js